import { loc, type Loc } from '../data/cards'
import { haptic } from '../lib/telegram'
import type { Lang } from '../data/cards'

export type TabId = 'home' | 'catalog' | 'compat' | 'profile'

/**
 * Вкладок по-прежнему четыре.
 *
 * Гадания без карт (кофе, ладонь, сны, персонажи) в отдельную вкладку не
 * выносим: подписи на азербайджанском и турецком в полтора раза длиннее
 * русских, и пятая уже не влезает в ряд — «Ana sayfa» и «Açılım» рядом
 * переносятся на две строки. Растёт каталог, а не навигация, поэтому
 * «Расклады» стали «Гаданиями» с секциями внутри.
 */
const TABS: ({ id: TabId; sym: string } & Loc)[] = [
  { id: 'home',    sym: '⌂', ru: 'Главная',  az: 'Əsas',    en: 'Home',     tr: 'Ana sayfa' },
  { id: 'catalog', sym: '✦', ru: 'Гадания',  az: 'Fallar',  en: 'Readings', tr: 'Fallar' },
  { id: 'compat',  sym: '☽', ru: 'Астро',    az: 'Astro',   en: 'Astro',    tr: 'Astro' },
  { id: 'profile', sym: '☰', ru: 'Профиль',  az: 'Profil',  en: 'Profile',  tr: 'Profil' },
]

export function TabBar({ active, lang, onGo }: { active: TabId; lang: Lang; onGo: (id: TabId) => void }) {
  return (
    <nav className="tabs">
      {TABS.map((tab) => (
        <button
          key={tab.id}
          type="button"
          aria-current={active === tab.id ? 'page' : undefined}
          onClick={() => {
            if (active !== tab.id) haptic.select()
            onGo(tab.id)
          }}
        >
          <span className="tab__sym">{tab.sym}</span>
          <span className="tab__label">{loc(tab, lang)}</span>
        </button>
      ))}
    </nav>
  )
}
